import React, { Component } from 'react';

import SidebarComponent from '../components/SidebarComponent';
import NavbarComponent from '../components/NavbarComponent';
import HeaderComponent from '../components/HeaderComponent';
import FormOpenTableComponent from '../components/FormOpenTableComponent';
import { createOpenTable } from '../utils/openTablesApi';
import { validateSession } from '../utils/functions';
import { navigateTo } from '../utils/navigation';

// Publicar una mesa abierta (FR-001…FR-008). Molde: AddEventPage.
class AddOpenTablePage extends Component {
    constructor() {
        super();
        this.state = { checked: false, role: 0, disabled: false };
    }

    async componentDidMount() {
        const role = await validateSession();
        this.setState({ checked: true, role });
    }

    handleChangeData = async (value) => {
        this.setState({ disabled: true });
        try {
            const data = await createOpenTable(value);
            const id = data && data.openTable && data.openTable.id;
            // A la ficha de la mesa nueva, con el link para compartir a mano. Sin id (no
            // debería pasar) queda el destino de antes.
            if (id) navigateTo(`/editOpenTable/${id}`, { state: { publicada: true } });
            else navigateTo('/openTables');
        } catch (error) {
            // openTablesApi ya resuelve el mensaje de negocio (70xx) y el redirect por 1002.
            console.error('No se pudo publicar la mesa abierta:', error);
            alert(error.message || 'Error de conexión');
            this.setState({ disabled: false });
        }
    }

    render() {
        if (!this.state.checked) {
            return (<div></div>);
        }
        return (
            <div className="container-fluid">
                <div className="row">
                    <SidebarComponent itemSelected={45} role={this.state.role} />
                    <main className="main-content col-lg-10 col-md-9 col-sm-12 p-0 offset-lg-2 offset-md-3">
                        <NavbarComponent role={this.state.role} />
                        <div className="main-content-container container-fluid px-4 mb-4">
                            <HeaderComponent title="Mesas abiertas" subtitle="Publicar mesa abierta" />
                            <FormOpenTableComponent
                                onChangeData={this.handleChangeData}
                                disabled={this.state.disabled}
                            />
                        </div>
                    </main>
                </div>
            </div>
        );
    }
}

export default AddOpenTablePage;
